import { packIndex } from '@/mocks/homeData';

export default function PackIndex() {
  return (
    <section id="packs" className="bg-background-100/70 py-12 md:py-16">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-accent-700">索引 · COLLECTIONS</p>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              打包合集 · 分类索引
            </h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
              六个方向的合集、汇总帖与补档都收在这份索引里，标题先行、按类取用，进合集前先看目录。
            </p>
          </div>
          <a
            href="#bigpack"
            className="inline-flex shrink-0 items-center gap-2 self-start whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700 md:self-auto"
          >
            想整段带走？看收藏大礼包
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {packIndex.map((card) => (
            <a
              key={card.name}
              href="#guide"
              className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
            >
              <div className="flex items-start justify-between gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-background-100 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className="ri-folder-5-fill text-lg"></i>
                </span>
                {card.hot && (
                  <span className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] font-semibold text-secondary-800">
                    <i className="ri-fire-fill text-xs"></i>
                    本周热
                  </span>
                )}
              </div>
              <h3 className="mt-4 text-[15px] font-bold text-foreground-950">{card.name}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{card.desc}</p>
              <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs">
                <span className="font-semibold text-foreground-800">{card.count} 条合集</span>
                <span className="inline-flex items-center gap-1 text-primary-700 opacity-0 transition-opacity group-hover:opacity-100">
                  查看索引 <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}